import {
    CalendarDaysIcon,
    DevicePhoneMobileIcon,
    ChartBarIcon,
    PhotoIcon,
    CurrencyDollarIcon,
} from '@heroicons/react/24/outline'
import type { ToolIconKey } from '@/data/tools'

/** The registry stays icon-library free so a Cloudflare Worker can import it. */
export const TOOL_ICONS: Record<ToolIconKey, typeof PhotoIcon> = {
    calendar: CalendarDaysIcon,
    device: DevicePhoneMobileIcon,
    chart: ChartBarIcon,
    photo: PhotoIcon,
    money: CurrencyDollarIcon,
}

/** Shared field styling, so every tool's inputs look and focus the same. */
export const TOOL_LABEL = 'block text-sm font-medium text-gray-700 dark:text-gray-300'
export const TOOL_INPUT =
    'w-full px-4 py-2.5 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder:text-gray-400 focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/30 text-sm'
export const TOOL_HINT = 'text-xs text-gray-500 dark:text-gray-400'
